import { DeleteEntityConfirmationModal } from '@/features/DirectoryGrid/components/DeleteEntityConfirmationModal';

interface DeletePersonConfirmationModalProps {
    isOpen: boolean;
    deleteInProgress?: boolean;
    count?: number;
    onConfirm: () => void;
    onCancel: () => void;
}

export function DeletePersonConfirmationModal(
    props: DeletePersonConfirmationModalProps,
) {
    return (
        <DeleteEntityConfirmationModal
            {...props}
            titleKey="persons.deletePerson"
            descriptionKey="persons.deleteConfirmation"
            submitKey="persons.card.delete"
            contentTestId="delete-person-confirm-modal"
            submitButtonTestId="delete-person-confirm-submit"
        />
    );
}
